import { Question } from "./QuestionTypes"

export const questions: Question[][] = [
	[
		{
			category: "national",
			challenge: "When is Mother's Day in Canada?",
			choices: [
				{ option: "First Saturday of May" },
				{ option: "Second Sunday of May", correct: true },
				{ option: "First Sunday of June" },
				{ option: "Third Sunday of June" },
			],
			citation:
				"https://www.cbc.ca/kidscbc2/the-feed/how-do-they-celebrate-mothers-day-in-other-countries#:~:text=Mother%27s%20Day%20takes%20place%20in,should%20have%20a%20special%20day.",
		},
		{
			category: "national",
			challenge: "How many Members of Parliament (including vacancies) are there?",
			choices: [{ option: "206" }, { option: "286" }, { option: "338", correct: true }, { option: "355" }],
			citation: "https://www.ourcommons.ca/members/en/search",
			reveal: "parliament.jpg",
		},
		{
			category: "tech",
			challenge: "Which font was added to Microsoft Office in 2021, named after a geological feature of BC?",
			choices: [
				{ option: "Fraser" },
				{ option: "Okanagan" },
				{ option: "Skeena", correct: true },
				{ option: "Whistler" },
			],
			reveal: "skeena.jpg",
		},
		{
			category: "literature",
			challenge: "What is the definition of diasporic",
			choices: [
				{ option: "Outside one's traditional homeland", correct: true },
				{ option: "Plantlife having male and female gametes within one flower" },
				{ option: "Plentiful and diverse" },
				{ option: "Unnecessarily extended, undirected conversation" },
			],
			citation: "https://www.dictionary.com/e/word-of-the-day/diasporic-2021-12-29/",
		},
		{
			category: "tech",
			challenge: "What kind of computer filename would typically end in .svg?",
			choices: [
				{ option: "Document" },
				{ option: "Executable program" },
				{ option: "Image", correct: true },
				{ option: "Video" },
			],
			reveal: "svg.svg",
		},
		// {
		// 	category: "national",
		// 	challenge: "What Coat of Arms is this?",
		// 	content: "sfu.png",
		// 	choices: [
		// 		{ option: "Hudson Bay Company" },
		// 		{ option: "Quebec City, QC" },
		// 		{ option: "Simon Fraser University", correct: true },
		// 		{ option: "Victoria, BC" },
		// 	],
		// 	reveal: "sfu.jpg",
		// },
		{
			category: "national",
			challenge: "What Coat of Arms is this?",
			content: "hbc-coa.jpg",
			choices: [
				{ option: "Hudson Bay Company", correct: true },
				{ option: "Quebec City, QC" },
				{ option: "Simon Fraser University" },
				{ option: "Victoria, BC" },
			],
			reveal: "hbc-coa2.jpg",
		},
		{
			category: "local",
			challenge:
				"As of 2022-01-01, BC workers are entitled to at least X paid sick days off and Y unpaid sick days off each year",
			choices: [{ option: "3, 1" }, { option: "3, 3" }, { option: "5, 0" }, { option: "5, 3", correct: true }],
		},
		{
			category: "literature",
			challenge: "When were the Lord of the Rings books first published?",
			choices: [
				{ option: "1954-1955", correct: true },
				{ option: "1958-1961" },
				{ option: "1960-1965" },
				{ option: "1971-1978" },
			],
			content: "lotr-cover.gif",
		},
		{
			challenge: "What is the peak market cap of all Bitcoin worldwide (USD)?",
			category: "economics",
			choices: [
				{ option: "970 Million" },
				{ option: "23 Billion" },
				{ option: "352 Billion" },
				{ option: "1.27 Trillion", correct: true },
			],
			reveal: "bitcoin.png",
			content: "bitcoin.svg",
			citation: "https://coinmarketcap.com/currencies/bitcoin/",
		},
		{
			challenge: "What are the top and bottom federal income tax brackets in Canada?",
			category: "economics",
			choices: [
				{ option: "15%, 33%", correct: true },
				{ option: "22%, 33%" },
				{ option: "15%, 45%" },
				{ option: "22%, 45%" },
			],
			citation:
				"https://www.canada.ca/en/revenue-agency/services/tax/individuals/frequently-asked-questions-individuals/canadian-income-tax-rates-individuals-current-previous-years.html",
		},
		{
			category: "tech",
			challenge: "Which is NOT a version of Android?",
			choices: [
				{ option: "Chocolate", correct: true },
				{ option: "KitKat" },
				{ option: "Lollipop" },
				{ option: "Pie" },
			],
			content: "android.svg",
		},
		{
			category: "world",
			challenge: "Order these people from youngest to oldest",
			choices: [
				{ option: "Bill Murray, Cher, Samuel L. Jackson" },
				{ option: "Bill Murray, Samuel L. Jackson, Cher", correct: true },
				{ option: "Cher, Samuel L. Jackson, Bill Murray" },
				{ option: "Samuel L. Jackson, Bill Murray, Cher" },
			],
			citation: "https://www.imdb.com/search/name/?birth_year=1950-01-01,1950-12-31",
		},
		{
			category: "national",
			challenge: "What is not a Canadian Cabinet Minister title?  Minister of...",
			choices: [
				{ option: "Seniors" },
				{ option: "Women and Gender Equality and Youth" },
				{ option: "Rural Economic Development" },
				{ option: "North American Affairs", correct: true },
			],
			citation: "https://pm.gc.ca/en/cabinet",
		},
		{
			category: "tech",
			challenge: "Which is NOT an HTML tag?",
			choices: [{ option: "A" }, { option: "H1" }, { option: "List", correct: true }, { option: "P" }],
		},
		{
			category: "economics",
			challenge: "What was the change in the Dow Jones Industrial Average in 2021?",
			choices: [{ option: "18.7%", correct: true }, { option: "24.2%" }, { option: "29.5%" }, { option: "35.0%" }],
			reveal: "djia.png",
			citation: "https://www.forbes.com/advisor/investing/stock-market-year-in-review-2021/",
		},
		{
			category: "industry",
			challenge: "When was the first Barbie doll released?",
			choices: [{ option: "1942" }, { option: "1948" }, { option: "1953" }, { option: "1959", correct: true }],
			content: "barbie.jpg",
		},
		{
			category: "film",
			challenge: "Which is a real storyline on Amazon Prime?",
			choices: [
				{ option: "Angelina Jolie babysits underprivileged children" },
				{ option: "Chris Pratt time travels to save the planet from aliens", correct: true },
				{ option: "Dane Cook is a cyber-crime investigator" },
				{ option: "Kanye West is a struggling 1940s fashion designer" },
			],
			reveal: "tomorrow-war.jpg",
		},
		{
			category: "industry",
			challenge: "What is the name of this knot?",
			content: "knots.jpg",
			choices: [
				{ option: "Fisherman's Knot", correct: true },
				{ option: "Square Knot" },
				{ option: "Half Hitch" },
				{ option: "Trucker's Hitch" },
			],
		},
		{
			category: "tech",
			challenge: "Which is NOT a version of macOS?",
			choices: [
				{ option: "Mountain Lion" },
				{ option: "Sea Lion", correct: true },
				{ option: "Sierra" },
				{ option: "Tiger" },
			],
			content: "macos.jpg",
			reveal: "sealion.jpg",
		},
		{
			category: "science",
			challenge: "Which was a contribution of Niels Bohr?",
			content: "niels-bohr.jpg",
			choices: [
				{ option: "A deep-sea drilling technique" },
				{ option: "A model describing electron behaviour", correct: true },
				{ option: "Discovery of ibuprofen" },
				{ option: "mRNA vaccine technologies" },
			],
			reveal: "bohr.svg",
		},
	],
	[
		{
			category: "tech",
			challenge: "What year did the original iPad launch?, +/- 1 year",
			content: "ipad.jpg",
			reveal: "ipad.mp4",
			answer: "April 3, 2010",
			citation: "https://en.wikipedia.org/wiki/IPad",
		},
		{
			category: "national",
			challenge: "What is the most circulated newspaper in Canada (News Media Canada, 2015)?",
			answer: "The Globe and Mail",
			reveal: "globe-mail.png",
			citation:
				"https://nmc-mic.ca/wp-content/uploads/2016/06/2015-Daily-Newspaper-Circulation-Report-REPORT_FINAL.pdf",
		},
		{
			category: "literature",
			challenge: "In what year was Wikipedia launched, +/- 2",
			tolerance: 2,
			answer: 2001,
			content: "wikipedia.svg",
			citation: "https://en.wikipedia.org/wiki/Wikipedia",
		},
		{
			category: "local",
			challenge: "What street borders the east side of Coast Mountain College?",
			answer: "Floyd Street",
			reveal: "floyd.jpg",
			content: "cmtn.jpg",
		},
		{
			category: "local",
			challenge: "In what year was Carol LeClerc first elected Mayor of Terrace, +/- 1 year",
			tolerance: 1,
			answer: "2014",
			content: "carol-leclerc.jpg",
			citation: "https://terrace.civicweb.net/portal/members.aspx?id=14",
		},
		{
			category: "world",
			challenge: "Who is this?",
			content: "magnus.jpg",
			answer: "Sven Magnus Øen Carlsen (Magnus), reigning World Chess Champion",
			reveal: "magnus2.jpg",
		},
		{
			category: "industry",
			challenge: "What model Lamborghini is this?",
			answer: "Urus",
			content: "urus.jpg",
			reveal: "urus.png",
			citation: "https://www.lamborghini.com/en-en/models/urus",
		},
		{
			challenge: "What building is this?",
			answer: "Supreme Court of Canada",
			category: "national",
			content: "supreme-court.jpg",
		},
		{
			challenge: "Who is the current Premier of Alberta?",
			answer: "Jason Kenney",
			reveal: "jason-kenney2.jpg",
			category: "national",
			citation: "https://www.alberta.ca/premier.aspx",
		},
		{
			category: "philosophy",
			challenge: "Who is this?",
			content: "jordan-peterson.jpg",
			answer: "Jordan Peterson, Canadian author/critic/psychologist/professor",
			reveal: "",
		},
		{
			category: "life",
			challenge: "What breed of horse is this?",
			content: "appaloosa.jpg",
			answer: " Appaloosa",
			citation: "https://horse-canada.com/breeds/appaloosa/",
		},
		{
			category: "literature",
			challenge: "Who wrote Guns, Germs and Steel",
			answer: "Jared Diamond",
			content: "ggs.jpg",
			reveal: "jared-diamond.webp",
		},
		{
			category: "film",
			challenge: "What is the name of the character called Captain Marvel?",
			answer: "Carol Susan Jane Danvers",
			content: "captain-marvel.jpg",
		},
		{
			category: "film",
			challenge: "What is this character's name or alias?",
			answer: "Omni-man / Nolan Grayson",
			content: "omni-man.jpg",
		},
		{
			category: "games",
			content: "among-us.jpg",
			answer: "Among Us",
			challenge: "What is the name of this game?",
			reveal: "among-us-splash.jpg",
		},
		{
			category: "world",
			challenge: "Who killed Alexander Hamilton?",
			content: "hamilton.jpg",
			answer: "Aaron Burr, Vice President",
			reveal: "aaron-burr.jpg",
		},
		{
			category: "science",
			challenge: "What is the name of the newly launched space telescope in the process of being deployed?",
			content: "jwst.png",
			answer: "James Webb Space Telescope",
		},
		{
			category: "world",
			challenge: "What is the capital of Saudi Arabia",
			answer: "Riyadh",
			reveal: "riyadh.jpg",
			content: "saudi.svg",
		},
		{
			category: "world",
			challenge: "In which country is Nantucket?",
			answer: "USA (Massachusetts)",
			reveal: "nantucket.png",
		},
		{
			category: "science",
			challenge: "Who is this?",
			content: "chris-hadfield.jpg",
			answer: "Chris Hadfield",
			reveal: "chris-hadfield2.jpg",
		},
	],
	[
		{
			category: "local",
			challenge: "What year did Sherwood Mountain Brewery open, +/- 1 year?",
			answer: 2014,
			tolerance: 1,
			content: "sherwood.jpg",
			citation: "https://www.sherwoodmountain.beer/story",
		},
		{
			category: "local",
			challenge: "What year was My Mountain Co-op founded, +/- 1 year?",
			answer: 2011,
			tolerance: 1,
			content: "mmc.png",
			citation: "https://mymountaincoop.ca/my-mountain-co-op/about/our-story/",
		},
		{
			category: "health",
			challenge: "In what month was the Omicron variant first detected?",
			answer: "2021-11-22",
			content: "omicron.svg",
			citation: "https://en.wikipedia.org/wiki/SARS-CoV-2_Omicron_variant",
		},
		{
			category: "industry",
			challenge: "What logo is this?",
			content: "discord.svg",
			reveal: "discord.jpg",
			answer: "Discord (chatroom app)",
		},
		{
			category: "literature",
			challenge: "What was Sherlock Holmes' brother's name?",
			answer: "Mycroft Holmes",
			content: "mycroft.jpg",
		},
		{
			category: "film",
			challenge: "What is the name of this movie?",
			answer: "They Live (1988)",
			content: "they-live.mp4",
			reveal: "they-live.jpg",
		},
		{
			category: "film",
			challenge: "What show is this?",
			content: "expanse.mp4",
			reveal: "expanse.jpg",
			answer: "The Expanse",
		},
		{
			category: "music",
			challenge: "Name the song",
			content: "perfect-question.mp4",
			reveal: "perfect-answer.mp4",
			answer: "Perfect (by Simple Plan)",
			fullscreen: true,
		},
		{
			category: "music",
			challenge: "Name the song",
			content: "going-under-question.mp4",
			reveal: "going-under-answer.mp4",
			answer: "Going Under (by Evanescence)",
			fullscreen: true,
		},
		{
			category: "film",
			challenge: "Name the movie",
			content: "lebowski.mp4",
			reveal: "lebowski.jpg",
			answer: "The Big Lebowski",
			fullscreen: true,
		},
		{
			category: "film",
			challenge: "Name the TV series",
			content: "foundation.mp4",
			reveal: "foundation.jpg",
			answer: "Foundation",
			fullscreen: true,
		},
		{
			category: "music",
			challenge: "Name the song",
			content: "dark-horse.mp4",
			reveal: "dark-horse.png",
			answer: "Dark Horse (by Katy Perry)",
			fullscreen: true,
		},
		{
			category: "film",
			challenge: "Name the movie",
			content: "eyes-wide-shut.mp4",
			reveal: "eyes-wide-shut.jpg",
			answer: "Eyes Wide Shut",
			fullscreen: true,
		},
		{
			category: "film",
			challenge: "Name the movie",
			content: "bill-and-ted.mp4",
			reveal: "bill-ted.jpg",
			answer: "Bill and Ted's Excellent Adventure",
			fullscreen: true,
		},
		{
			category: "film",
			challenge: "Name the movie",
			content: "highlander.mp4",
			reveal: "highlander.jpg",
			answer: "Highlander",
			fullscreen: true,
		},
		{
			category: "film",
			challenge: "Name the movie",
			content: "rotn.mp4",
			reveal: "rotn.jpg",
			answer: "Revenge of the Nerds",
			fullscreen: true,
		},
		{
			category: "music",
			challenge: "Name the song",
			content: "rule-britannia-question.mp4",
			reveal: "rule-britannia-answer.mp4",
			answer: "Rule Britannia",
			fullscreen: true,
		},
		{
			category: "film",
			challenge: "Name the TV series",
			content: "schitts-creek.mp4",
			reveal: "schitts-creek.jpg",
			answer: "Schitt's Creek",
			fullscreen: true,
		},
		{
			category: "film",
			challenge: "Name the EXACT movie",
			content: "half-blood.mp4",
			answer: "Hary Potter and the Half-Blood Prince",
			reveal: "half-blood.jpg",
			fullscreen: true,
		},
		{
			category: "film",
			challenge: "What movie is this?",
			content: "black-swan.mp4",
			answer: "Black Swan",
			reveal: "black-swan.jpg",
			fullscreen: true,
		},
	],
]
